import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { SharedModule } from '../shared/shared.module';
import { MonthPickerComponent } from '../shared/month/month-picker.component';
import { DashboardCardComponent } from '../shared/dashboard/dashboard-card.component';

import { FinancesRoutingModule } from './finances-routing.module';
import { FinancesComponent } from './finances.component';
import { EntriesComponent } from './entries/entries.component';
import { EntryDialogComponent } from './entries/entry-dialog.component';
import { CardsComponent } from './cards/cards.component';
import { CardDialogComponent } from './cards/card-dialog.component';
import { CardItemDialogComponent } from './cards/card-item-dialog.component';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryDialogComponent } from './categories/category-dialog.component';


@NgModule({
  declarations: [
    FinancesComponent,
    EntriesComponent,
    EntryDialogComponent,
    CardsComponent,
    CardDialogComponent,
    CardItemDialogComponent,
    CategoriesComponent,
    CategoryDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    SharedModule,

    FinancesRoutingModule,

    MonthPickerComponent,
    DashboardCardComponent,

    BaseChartDirective,

    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatTableModule
  ],
  providers: [
    provideCharts(withDefaultRegisterables())
  ]
})
export class FinancesModule { }
